// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39sgb","footer":"styles_footer__1B5SP"};